import { IonCol, IonIcon, IonItemDivider, IonRow, IonText } from '@ionic/react';
import React, { useMemo } from 'react';
import { returnDownForward } from 'ionicons/icons';
import styles from './PendingDepositsItem.module.css';
import { CryptoDepositTravelRule, depositCryptoState, TravelRuleType } from '@/types/crypto';
import { getShortDateTimeString } from '@/shared/helpers/formatters';
import { useTranslation } from 'react-i18next';

type Props = {
  depositItem: CryptoDepositTravelRule;
  handleInitiateTravelRule: (value: boolean, cryptoData: depositCryptoState, type?: TravelRuleType) => void;
};

const PendingDepositsItem: React.FC<Props> = ({ depositItem, handleInitiateTravelRule }) => {
  const { sourceAddress, amount, assetId, createdAt, depositIntentId, uuid } = depositItem;
  const { t } = useTranslation();

  const formattedCreatedAt = useMemo(() => {
    if (!createdAt) return '';

    return getShortDateTimeString(new Date(createdAt));
  }, [createdAt]);

  const handleTravelRuleDeposit = () => {
    handleInitiateTravelRule(
      true,
      {
        id: uuid,
        intentId: depositIntentId
      },
      TravelRuleType.Deposit
    );
  };

  return (
    <IonRow>
      <IonCol size="8" className={styles.descriptionContainer}>
        <IonText className={styles.address} color={'primary'}>
          {sourceAddress}
        </IonText>
        <IonText className={styles.amount}>{`${amount} ${assetId.toUpperCase()}`}</IonText>
        <IonText className={styles.dateTime} color={'medium'}>
          {formattedCreatedAt}
        </IonText>
      </IonCol>
      <IonCol size="4">
        <div className={styles.buttonContainer} role="button" onClick={handleTravelRuleDeposit}>
          <IonIcon className={styles.buttonIcon} icon={returnDownForward} color={'light'} />
          <IonText color={'light'} className={styles.buttonLabel}>
            {t('general.price.proceed')}
          </IonText>
        </div>
      </IonCol>
      <IonItemDivider className={styles.divider} />
    </IonRow>
  );
};

export default React.memo(PendingDepositsItem);
